import { addStyles } from 'ethcss'
import { IStyles, mediaCSS, palette } from 'theme'

const NotificationEmails: IStyles = {
    notificationList: {},
    deleteConfirm: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0, 0.7)',
        zIndex: 10000,
    },
    deleteConfirmInner: {
        backgroundColor: palette.white.main,
        borderRadius: 20,
        padding: 20,
    },
    deleteConfirmMessage: {
        marginBottom: 24,
        textAlign: 'center',
    },
    deleteConfirmButtons: {
        display: 'flex',
        justifyContent: 'center',
    },
    button: {
        margin: '0 6px',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginBottom: 14,
    },
    emailBody: {
        width: '100%',
        overflow: 'hidden',
        '& img': {
            maxWidth: '100%',
            height: 'auto',
        },
        '& table': {
            maxWidth: '100%',
        },
        '& a': {
            overflowWrap: 'anywhere',
        },
    },
    group: {
        display: 'flex',
        alignItems: 'center',
        gap: 20,
    },
    caption: {
        display: 'flex',
        marginBottom: 14,
        color: palette.neutral,
        fontSize: 13,
        lineHeight: '18px',
    },
    changeSettings: {
        marginLeft: 16,
        color: palette.brandBlue.main,
        cursor: 'pointer',
    },
    table: {
        width: '100%',
        overflowX: 'auto',
        borderRadius: 4,
        backgroundColor: palette.white,
    },
    tableHeader: {
        display: 'grid',
        gridTemplateColumns:
            '42px minmax(108px, .7fr) minmax(140px, .9fr) minmax(170px, 1.1fr) minmax(260px, 2fr) 36px',
        alignItems: 'center',
        minWidth: 900,
        minHeight: 38,
        padding: '0 10px',
        backgroundColor: palette.neutral[100],
        color: palette.neutral,
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 500,
    },
    checkboxCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    rowAction: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    emptyState: {
        padding: '48px 20px',
        //color: colors.greyEditor2,
        textAlign: 'center',
    },
    emailsWrapper: {
        [mediaCSS.tab]: {
            paddingTop: 60,
        },
    },
}

addStyles(NotificationEmails)
export default NotificationEmails
